<div class="full-width m-t-0-5" *ngIf="!isAccountTypeAdmin && carrierVettingService.isMCPEnabled()">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<span *ngIf="isCarrierInNetwork" fxLayoutAlign="start center">
						<img src="assets/icons/mcp_logo.png" class="mcp_image_container pr-8" />
						<span class="mcp_text">MyCarrierPortal </span>
					</span>
					<span *ngIf="!isCarrierInNetwork">C4</span>
					<span> &nbsp;Risk Assessment </span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingOverallDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(allInfractions)"
						[matTooltip]="TOOL_TIP_MESSAGE(allInfractions)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(allInfractions) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOverallDisplay, carrierActive, false, isMCPEnabled) }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingAuthorityDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.authority)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.authority)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.authority) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingAuthorityDisplay, carrierActive, false, isMCPEnabled) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingInsuranceDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.insurance)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.insurance)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.insurance) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingInsuranceDisplay, carrierActive, false, isMCPEnabled) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOperationsDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.operations)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.operations)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.operations) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOperationsDisplay, carrierActive, false, isMCPEnabled) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.safety)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.safety)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.safety) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingSafetyDisplay, carrierActive, false, isMCPEnabled) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Other</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.other)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.other)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.other) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOtherDisplay, carrierActive, false, isMCPEnabled) }}
						</span>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<div
	class="full-width m-t-0-5"
	*ngIf="!isAccountTypeAdmin && carrierVettingService.isRMISEnabled()"
>
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<img src="assets/icons/rmisImage.png" class="rmis_image_container" />
				</div>
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="end center">
					Risk Assessment
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ getOverallDisplayClass() }}"
					fxLayoutAlign="end center"
					[matTooltipDisabled]="IS_EMPTY_LIST(allInfractions)"
					[matTooltip]="TOOL_TIP_MESSAGE(allInfractions)"
					matTooltipClass="custom-tooltip"
					[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(allInfractions) }"
				>
					{{ GET_QUALITY_DISPLAY(vettingOverallDisplay, carrierActive) }}
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingAuthorityDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.authority)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.authority)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.authority) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingAuthorityDisplay, carrierActive) }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingInsuranceDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.insurance)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.insurance)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.insurance) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingInsuranceDisplay, carrierActive) }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOperationsDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.operations)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.operations)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.operations) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOperationsDisplay, carrierActive) }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.safety)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.safety)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.safety) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingSafetyDisplay, carrierActive) }}
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Other</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.other)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.other)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.other) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOtherDisplay, carrierActive) }}
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<div
	class="full-width m-t-0-5"
	*ngIf="!isAccountTypeAdmin && carrierVettingService.isHighwayEnabled()"
>
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<span *ngIf="isCarrierInNetwork" fxLayoutAlign="start center">
						<img src="assets/icons/2025_Highway H logo.png" class="mcp_image_container pr-8" />
						<span class="highway_text">Highway </span>
					</span>
					<span *ngIf="!isCarrierInNetwork">C4</span>
					<span> &nbsp;Risk Assessment </span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingOverallDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(allInfractions)"
						[matTooltip]="TOOL_TIP_MESSAGE(allInfractions)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(allInfractions) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOverallDisplay, carrierActive) }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingAuthorityDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.authority)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.authority)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.authority) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingAuthorityDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingInsuranceDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.insurance)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.insurance)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.insurance) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingInsuranceDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOperationsDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.operations)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.operations)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.operations) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOperationsDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.safety)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.safety)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.safety) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingSafetyDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Other</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.other)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.other)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.other) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOtherDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<div
	class="full-width m-t-0-5"
	*ngIf="
		!isAccountTypeAdmin &&
		!carrierVettingService.isRMISEnabled() &&
		!carrierVettingService.isMCPEnabled() &&
		!carrierVettingService.isHighwayEnabled() &&
		!forCarrierAccount
	"
>
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					Risk Assessment
				</div>
				<div
					fxFlex
					class="font-size-16 font-weight-bold success-text"
					fxLayoutAlign="end center"
				></div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{ GET_QUALITY_CLASS(vettingOverallDisplay, carrierActive) }}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(allInfractions)"
						[matTooltip]="TOOL_TIP_MESSAGE(allInfractions)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(allInfractions) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOverallDisplay, carrierActive) }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingAuthorityDisplay, carrierActive)
						}}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.authority)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.authority)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.authority) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingAuthorityDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingInsuranceDisplay, carrierActive)
						}}"
						fxLayoutAlign="end center"
					>
						<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
							<span
								*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
								[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.insurance)"
								[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.insurance)"
								matTooltipClass="custom-tooltip"
								[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.insurance) }"
							>
								{{ GET_QUALITY_DISPLAY(vettingInsuranceDisplay, carrierActive) }}
							</span>
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingOperationsDisplay, carrierActive)
						}}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.operations)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.operations)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.operations) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOperationsDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.safety)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.safety)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.safety) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingSafetyDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>

			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Other</div>
				<div fxFlex fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{ GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive) }}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.other)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.other)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.other) }"
						>
							{{ GET_QUALITY_DISPLAY(vettingOtherDisplay, carrierActive) }}
						</span>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<!-- admin will no vetting integrations enabled, this will display data at carrier level -->
<div class="full-width m-t-0-5" *ngIf="isAccountTypeAdmin || forCarrierAccount">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="">
			<ng-template [ngTemplateOutlet]="ccScore"></ng-template>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
					<span> &nbsp;Risk Assessment </span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Overall</div>
				<div
					fxFlex
					class="font-size-14 {{
						GET_QUALITY_CLASS(vettingOverallDisplay, carrierActive, forBrokerQualityData)
					}}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(allInfractions)"
						[matTooltip]="TOOL_TIP_MESSAGE(allInfractions)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(allInfractions) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOverallDisplay, carrierActive, forBrokerQualityData) }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Authority</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingAuthorityDisplay, carrierActive, forBrokerQualityData)
						}}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.authority)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.authority)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.authority) }"
						>
							{{
								GET_QUALITY_DISPLAY(vettingAuthorityDisplay, carrierActive, forBrokerQualityData)
							}}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Insurance</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingInsuranceDisplay, carrierActive, forBrokerQualityData)
						}}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.insurance)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.insurance)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.insurance) }"
						>
							{{
								GET_QUALITY_DISPLAY(vettingInsuranceDisplay, carrierActive, forBrokerQualityData)
							}}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Operations</div>
				<div fxFlex class="font-size-14" fxLayoutAlign="end center">
					<div
						fxFlex
						class="font-size-14 {{
							GET_QUALITY_CLASS(vettingOperationsDisplay, carrierActive, forBrokerQualityData)
						}}"
						fxLayoutAlign="end center"
					>
						<span
							*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
							[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.operations)"
							[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.operations)"
							matTooltipClass="custom-tooltip"
							[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.operations) }"
						>
							{{
								GET_QUALITY_DISPLAY(vettingOperationsDisplay, carrierActive, forBrokerQualityData)
							}}
						</span>
					</div>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Safety</div>
				<div
					fxFlex
					class="font-size-14 {{
						GET_QUALITY_CLASS(vettingSafetyDisplay, carrierActive, forBrokerQualityData)
					}}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.safety)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.safety)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.safety) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingSafetyDisplay, carrierActive, forBrokerQualityData) }}
					</span>
				</div>
			</div>
			<div fxLayout="row" class="padding-0-5">
				<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Other</div>
				<div
					fxFlex
					class="font-size-14 {{
						GET_QUALITY_CLASS(vettingOtherDisplay, carrierActive, forBrokerQualityData)
					}}"
					fxLayoutAlign="end center"
				>
					<span
						*ngIf="!isLoadingCarrierQualityFromMcp; else skeletonLoader"
						[matTooltipDisabled]="IS_EMPTY_LIST(infractionDetails?.other)"
						[matTooltip]="TOOL_TIP_MESSAGE(infractionDetails?.other)"
						matTooltipClass="custom-tooltip"
						[ngClass]="{ 'cursor-pointer': IS_NOT_EMPTY_LIST(infractionDetails?.other) }"
					>
						{{ GET_QUALITY_DISPLAY(vettingOtherDisplay, carrierActive, forBrokerQualityData) }}
					</span>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>

<ng-template #skeletonLoader>
	<div fxFlex fxLayoutAlign="end center">
		<app-skeleton-loader
			[SHOW_SINGLE_LOADER]="true"
			class="skeletonLoaderWidth"
		></app-skeleton-loader>
	</div>
</ng-template>

<ng-template #ccScore>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-16 font-weight-bold primary-text" fxLayoutAlign="start center">
			Overall
		</div>
		<div
			fxFlex
			class="font-size-16 font-weight-bold {{
				GET_CC_OVERALL_CLASS(ccScoreDisplay, carrierActive, forBrokerQualityData)
			}}"
			fxLayoutAlign="end center"
		>
			{{ GET_CC_OVERALL_DISPLAY(ccScoreDisplay, carrierActive, forBrokerQualityData) }}
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Loads Booked</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingCarriersLoadsList; else skeletonLoader">
					{{ ccTotalBookedLoads || (forBrokerQualityData ? '-' : 'N/A') }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Fall-Off Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccFalloffRateDisplay || (forBrokerQualityData ? '-' : 'N/A') }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Engagement Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccEngagementRateDisplay || (forBrokerQualityData ? '-' : 'N/A') }}
				</span>
			</div>
		</div>
	</div>
	<div fxLayout="row" class="padding-0-5">
		<div fxFlex class="font-size-14 primary-text" fxLayoutAlign="start center">Booking Rate</div>
		<div fxFlex class="font-size-14" fxLayoutAlign="end center">
			<div fxFlex class="font-size-14" fxLayoutAlign="end center">
				<span *ngIf="!isLoadingQualityScoreDetails; else skeletonLoader">
					{{ ccBookingRateDisplay || (forBrokerQualityData ? '-' : 'N/A') }}
				</span>
			</div>
		</div>
	</div>
</ng-template>
